export default __webpack_public_path__ + "static/main-logo-ff46b12e9806f3e69ae84a221800aea0.png";